<template>
  <div class="event-calendar-print pt-3">
    <h1 class="text-center mb-4">{{ month | moment("MMMM YYYY") }}</h1>
    <Calendar :month="month">
      <template v-slot:day="{ day }">
        <div class="date">{{ day }}</div>
        <div v-for="(event, i) in events(day)" :key="i" class="event px-2 mb-3">
          <span class="font-size-sm font-weight-bold text-dark"
            >{{ event.start_date | moment("h:mma") }} -
          </span>
          {{ event.name }}
        </div>
      </template>
    </Calendar>
  </div>
</template>

<script>
import ListingMixin from "mixins/Listing";
export default {
  mixins: [ListingMixin],
  data() {
    return {
      month: this.$moment().format("YYYY-MM"),
    };
  },
  watch: {
    items(val) {
      this.$nextTick(() => {
        window.print();
      });
    },
  },
  methods: {
    customParams() {
      return { month: this.month };
    },
    events(day) {
      return this.items.filter((item) => {
        var start = parseInt(this.$moment(item.start_date).format("D"), 10);
        var end = parseInt(this.$moment(item.end_date).format("D"), 10);
        return day >= start && day <= end;
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style lang="scss">
@import "sass/_variables";
.event-calendar-print {
  background-color: #ffffff;

  .calendar {
    th {
      border-top: 1px solid $gray-300;
      width: 14.286%;
    }
    td {
      border-left: 1px solid $gray-300;
      height: 10vw;
      text-align: left;
    }
    .event {
      color: $gray-600;
      font-size: 14px;
      line-height: 14px;
    }
    .disabled .event {
      display: none;
    }
  }
}
</style>